'use client'

import SearchPropertyPopupProvider from '@/context/search-property-popup'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import StripeProvider from './StripeProvider'

export default function MainContainer({
  children,
}: Readonly<{
  children: React.ReactNode
}>) {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 minutes
      },
    },
  })

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <StripeProvider>
          <SearchPropertyPopupProvider>
            <main className="min-h-[25vh]">{children}</main>
          </SearchPropertyPopupProvider>
        </StripeProvider>
      </QueryClientProvider>
    </>
  )
}
